<template>
    <div>
        <div class="box" v-loading="loading" element-loading-text="正在进入工单管理后台...">
        </div>
    </div>
</template>

<script>
import api from "plus/api";
import config from "plus/config";
import { mapActions } from "vuex";
export default {
    name: "login",
    data() {
        return {
            loading: true,
        };
    },

    created() {
        // this.getData();
        this.loginByWorkWx()
    },
    methods: {
        ...mapActions(["updateToken"]),
        getData() {
            let that = this;
            let { token } = this.$route.query || {};
            api.login.loginData({ token, sourceType: 333 }).then((q) => {
                let { data, success, msg } = q.data || {};
                if (success) {
                    window.localStorage.setItem("ucToken", token);
                    that.$auth.token = token;
                    this.updateToken(data.token)
                    const targetUrl = sessionStorage.getItem('redirectUrl') || '';
                    sessionStorage.removeItem('redirectUrl');
                    if (targetUrl) {
                        window.location.replace(targetUrl);
                    } else {
                        this.$router.replace({ name: 'work.index.homeIndex' }).catch((e) => {
                        });
                    }
                }
            }).catch((e) => {
                this.loading = false;
                this.$alert(
                    "请联系管理员或尝试重新从UC进入工单系统",
                    "登录失败",
                    {
                        confirmButtonText: "进入UC",
                        confirmButtonClass: 'confirmBtn',
                        showClose: false,
                        callback: () => {
                            window.location.replace(config.UC_HOST);
                        },
                    }
                );
            });
        },
        async loginByWorkWx() {
            const code = this.getQueryString("code");
            console.log("获取code",code)
            if (code) {
                const res = await api.login.getTokenByWorkWxCode(code);
                if (res.data.success) {
                    this.getDataByToken(res.data.data)
                }else{
                    this.$element.message.error("没有获取到token;code:",code)
                }
            } else {
                this.getData()
            }
        },
        getQueryString(name) {
            const search = window.location.search || '';
            if(search!=''){
                const params = new URLSearchParams(search);
                return params.get(name);
            }else{
                const hash = window.location.hash;
                const queryString = hash.split('?')[1] || '';
                const searchParams = new URLSearchParams(queryString);
                return searchParams.get(name);
            }
        },
        getDataByToken(token) {
            let that = this;
            api.login.loginData({ token, sourceType: 333 }).then((q) => {
                let { data, success, msg } = q.data || {};
                if (success) {
                    window.localStorage.setItem("ucToken", token);
                    that.$auth.token = token;
                    this.updateToken(data.token)
                    let targetUrl = sessionStorage.getItem('redirectUrl')||''
                    sessionStorage.removeItem('redirectUrl');
                    if(targetUrl){
                        window.location.replace(targetUrl)
                    }else{
                        console.log("没有回调地址。跳转首页")
                        this.$router.replace({ name: 'work.index.homeIndex' })
                    }
                }
            }).catch((e) => {
                this.loading = false;
                this.$alert(
                    "请联系管理员或尝试重新从UC进入工单系统",
                    "登录失败",
                    {
                        confirmButtonText: "进入UC",
                        confirmButtonClass: 'confirmBtn',
                        showClose: false,
                        callback: () => {
                            window.location.replace(config.UC_HOST);
                        },
                    }
                );
            });
        },
    },
};
</script>

<style scoped>
.box {
    width: 100vw;
    height: 100vh;
}
</style>
